import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function apiUpdateColumnSettings(
  columnConfiguration: { code: string; visible: boolean }[],
  resetPosition = false,
  fromOrderBook?: boolean,
): Promise<Response> {
  const requestFrom = fromOrderBook ? "orderBookPreferences" : "columnPreferences";
  const body = {
    [requestFrom]: {
      showVisibilityUpdate: {
        codes: columnConfiguration.filter((item) => item.visible).map((item) => item.code),
      },
      hideVisibilityUpdate: {
        codes: columnConfiguration.filter((item) => !item.visible).map((item) => item.code),
      },
      positionUpdate: columnConfiguration.map((item, index) => ({
        code: item.code,
        position: resetPosition ? undefined : index,
      })),
    },
  };

  const url = occUrl("/preferences/updatePreferences");

  return occFetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}
